import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { IServerSideGetRowsParams } from 'ag-grid-enterprise';
import { forkJoin } from 'rxjs';
import { Site } from 'src/app/classes/models';
import { AuthService } from 'src/app/services/auth.service';
import { SiteService } from 'src/app/services/site.service';

import { GridService } from '../../services/grid.service';
import { UtilityService } from '../../services/utility.service';
import { BaseGridComponent } from '../base-grid/base-grid.component';

@Component({
  selector: 'app-sites-grid',
  templateUrl: '../base-grid/base-grid.component.html',
  styleUrls: [
    './sites-grid.component.less',
    '../base-grid/base-grid.component.less'
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SitesGridComponent extends BaseGridComponent implements OnInit {
  constructor(
    protected override GridService: GridService,
    protected override UtilityService: UtilityService,
    protected override AuthService: AuthService,
    private SiteService: SiteService
  ) {
    super(GridService, UtilityService, AuthService);

    this.gridPrimaryKeyFieldName = 'id';
    this.gridType = 'Site';
    this.rowModelType = 'serverSide';
    this.suppressFieldDotNotation = false;

    this.ServerSideDataSource = {
      getRows: (params: IServerSideGetRowsParams) => {
        const { request } = params;

        const queryObject = this.constructGridQuery({ request });
        const countQueryObject = this.constructGridQuery(
          { request },
          { isCountQuery: true }
        );

        forkJoin([
          this.SiteService.getSites(queryObject),
          this.SiteService.getSiteCount(countQueryObject)
        ]).subscribe({
          next: ([Sites, siteCount]) => {
            const successObject: { rowData: Site[]; rowCount: number } = {
              rowData: Sites,
              rowCount: siteCount
            };

            params.success(successObject);
          },
          error: (error) => {
            console.log(error);
            params.fail();
          }
        });
      }
    };
  }
}
